import { To } from "react-router-dom";
import { BackButton } from "app/components/ui/buttons/BackButton";
import { BookingBackButton } from "app/features/booking/steps";

type HeaderBackButtonProps = {
	isBookingPage?: boolean;
	clickableFromSanity?: boolean;
	isMobile?: boolean;
	onClick?: () => void;
	fallbackTo?: To;
};

/** Renders the step-aware back button on booking pages (desktop, when the brand enables it), and the plain back button everywhere else. */
export const HeaderBackButton = ({
	isBookingPage = false,
	clickableFromSanity = false,
	isMobile = false,
	onClick,
	fallbackTo,
}: HeaderBackButtonProps) => {
	if (isBookingPage && !isMobile && clickableFromSanity) {
		return <BookingBackButton onClick={onClick} />;
	}

	return <BackButton to={fallbackTo} onClick={onClick} />;
};
